import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import { Show } from '../../../../../react-commons/components/control-flow/Show';
import type { FormNames } from '../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import {
    type SystemAnnouncementResource,
    SystemSystemAnnouncementPropertyValidation,
} from '../../../resource/resources/persistables/system/announcement/systemAnnouncementResource';
import type { PropertyValidationInformation } from '../../util/PropertyValidationInformation';
import { PropertyInputs } from '../base/property-bases/PropertyInputs';

export const SystemAnnouncementContent = ({
    id,
    form,
    formNames,
    readOnly,
    withoutTimes,
}: {
    id?: string;
    form: UseFormReturn<SystemAnnouncementResource>;
    formNames: FormNames<SystemAnnouncementResource>;
    readOnly: boolean;
    withoutTimes?: boolean;
}) => {
    const propertyValidationInformationBase: PropertyValidationInformation = {
        resourceId: id,
        resourceType: ResourceType.SYSTEM_ANNOUNCEMENT,
        propertyIdentifier: '',
    };

    return (
        <Grid>
            <Grid.Col span={12}>
                <PropertyInputs.String
                    nullable={false}
                    control={form.control}
                    name={formNames.title}
                    readOnly={readOnly}
                    propertyValidationInformation={{
                        ...propertyValidationInformationBase,
                        propertyIdentifier: SystemSystemAnnouncementPropertyValidation.TITLE,
                    }}
                />
            </Grid.Col>
            <Grid.Col span={12}>
                <PropertyInputs.MultilineString
                    nullable={false}
                    control={form.control}
                    name={formNames.text}
                    readOnly={readOnly}
                    propertyValidationInformation={{
                        ...propertyValidationInformationBase,
                        propertyIdentifier: SystemSystemAnnouncementPropertyValidation.TEXT,
                    }}
                />
            </Grid.Col>
            <Show when={!withoutTimes}>
                <Grid.Col span={6}>
                    <PropertyInputs.Date
                        control={form.control}
                        name={formNames.activeFrom}
                        readOnly={readOnly}
                        propertyValidationInformation={{
                            ...propertyValidationInformationBase,
                            propertyIdentifier: SystemSystemAnnouncementPropertyValidation.ACTIVE_FROM,
                        }}
                    />
                </Grid.Col>
                <Grid.Col span={6}>
                    <PropertyInputs.Date
                        control={form.control}
                        name={formNames.activeUntil}
                        readOnly={readOnly}
                        propertyValidationInformation={{
                            ...propertyValidationInformationBase,
                            propertyIdentifier: SystemSystemAnnouncementPropertyValidation.ACTIVE_UNTIL,
                        }}
                    />
                </Grid.Col>
            </Show>
        </Grid>
    );
};
